import { ENTORNO } from './entorno.js';
// ══════════════════════════════════════════════════════════════════════
//  GEOBAJA — El sitio público, en un solo lugar.
//
//  El dominio estaba escrito a mano en 16 archivos: los QR de verificación
//  de reporte, los de identidad del firmante, las etiquetas del laboratorio
//  y el portal de descargas que se le dicta al cliente. Cambiar de dominio
//  era tocar código, y ninguna de esas copias sabía de las otras.
//
//  Regla: NADIE vuelve a escribir 'geobajaingenieria.com' en el código.
//  Se pide la URL a este módulo.
//
//  Por qué NO es `window.location.origin`: estas URLs viajan impresas en un
//  PDF o en una etiqueta que sobrevive al navegador que la generó. Un QR
//  armado desde localhost o desde un preview de Vercel apuntando ahí es un
//  documento roto en manos del cliente. El sitio público es un dato de
//  configuración del despliegue, no del navegador. Se puede mover con
//  REACT_APP_SITIO_URL sin tocar una línea.
// ══════════════════════════════════════════════════════════════════════

// Sin diagonal final: todas las rutas de abajo la ponen.
export const SITIO = (ENTORNO.SITIO_URL || 'https://geobajaingenieria.com')
  .trim()
  .replace(/\/+$/, '');

// Para MOSTRAR (se le dicta al cliente por teléfono o se copia a un correo):
// sin protocolo, que es como la gente escribe una dirección.
export const SITIO_HOST = SITIO.replace(/^https?:\/\//, '');

// Portal público de descargas por folio + clave de obra (App.js → /reportes).
export const PORTAL_REPORTES     = `${SITIO_HOST}/reportes`;
export const urlPortalReportes   = () => `${SITIO}/reportes`;

// Rutas públicas sin sesión (ver App.js).
export const urlVerificar   = (id)    => `${SITIO}/verificar/${id || ''}`;
export const urlFirmante    = (slug)  => `${SITIO}/firmante/${slug || ''}`;
export const urlAcuse       = (token) => `${SITIO}/acuse/${token || ''}`;

// Deep-link interno del laboratorio (exige sesión; la etiqueta impresa dura
// más que cualquier despliegue, por eso también sale de aquí).
export const urlMuestraLab  = (id)    => `${SITIO}/laboratorio/m/${id || ''}`;
